import * as data from '~~/app-version.json'

export const version = data.version

export default (context, inject) => {
  inject('appVersion', version)
}
